import Utils from "../../../utility";

const initialState = {
  order: "DESC",
  sortField: "",
  offset: 1,
  take: 20,
  search: "",
  isActive: null,
  storeId: "",
  couponDetail: {},
};

export const couponReducer = (state = initialState, action) => {
  switch (action.type) {
    case `${Utils.ActionName.COUPON}`:
      return {
        ...state,
        ...action.payload,
      };
    case `${Utils.ActionName.RESET_COUPON}`:
      return initialState;
    default:
      return { ...state };
  }
};
